import {observer} from 'mobx-react-lite'
import React from 'react'
import {ObjectType} from 'yougile-model'
import {IconButtonNew} from '@components/common/base/buttons'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {cn} from '@containers/html-utils'

interface Props {
  path: string
  className?: string
  type: ObjectType
}

export const Chevron = observer((props: Props) => {
  const {path, className, type} = props
  const [, store] = useTimelineNewStore()
  const expanded = store.getExpanded({type, path})

  return (
    <IconButtonNew
      className={cn(className, '!w-24 !h-24 p-4 -mx-4')}
      icon={expanded ? 'IconChevronUp' : 'IconChevronDown'}
      onClick={e => {
        e.stopPropagation()
        store.toggleExpanded(path, type)
      }}
    />
  )
})
